const SystemDefaults = new class SystemDefaults {
    defaultEditorSettings() { return { useBoundsWidget: false }; }
    defaultGraphColor() { return "#43BF3F"; }
    defaultGraphingSettings(isDark) {
        const colorAxes = isDark
            ? "rgba(0, 0, 0, 0.8)"
            : "rgba(255, 255, 255, 0.8)";
        const colorMajor = isDark
            ? "rgba(0, 0, 0, 0.2)"
            : "rgba(255, 255, 255, 0.2)";
        const colorText = isDark
            ? "rgba(0, 0, 0, 0.5)"
            : "rgba(255, 255, 255, 0.5)";
        const colorMinor = isDark
            ? "rgba(0, 0, 0, 0.1)"
            : "rgba(255, 255, 255, 0.1)";
        const colorTextShadow = isDark
            ? "rgba(128, 128, 128, 0.2)"
            : "rgba(0, 0, 0, 0.2)";

        return {
            showAxisX: true,
            showAxisY: true,
            showAxisTitles: true,
            showAxisNumbers: true,
            showAxisArrowX: "both",
            showAxisArrowY: "both",
            axisWidth: 1.5,
            showGrid: true,
            colorBackground: "transparent",
            colorAxes,
            colorText,
            colorTextShadow,
            colorMajor,
            colorMinor,
            gridType: "unit",
            viewerInteractable: true,
            range: {
                rangeX: new THREE.Vector2(-5, 5),
                rangeY: new THREE.Vector2(-5, 5),
                locked: true
            }
        };
    }

    defaultShadowSettings() {
        return {
            enabled: false,
            color: "#000000",
            position: -0.5,
            radius: 1.5,
            opacity: 1
        };
    }

    getOutlineSettings(settings = {}) {
        return {
            colorForeground: "colorForeground" in settings ? settings.colorForeground : 0x555599,
            colorBackground: "colorBackground" in settings ? settings.colorBackground : 0x000033,
            edgeGlow: "edgeGlow" in settings ? settings.edgeGlow : 1,
            edgeThickness: "edgeThickness" in settings ? settings.edgeThickness : 2,
            edgeStrength: "edgeStrength" in settings ? settings.edgeStrength : 5,
            pulsePeriod: "pulsePeriod" in settings ? settings.pulsePeriod : 0
        };
    }

    getHighlightSettings(settings = {}) {
        return {
            colorForeground: "colorForeground" in settings ? settings.colorForeground : 0xff8000,
            colorBackground: "colorBackground" in settings ? settings.colorBackground : 0x373737,
            edgeGlow: "edgeGlow" in settings ? settings.edgeGlow : 1,
            edgeThickness: "edgeThickness" in settings ? settings.edgeThickness : 2,
            edgeStrength: "edgeStrength" in settings ? settings.edgeStrength : 4,
            pulsePeriod: "pulsePeriod" in settings ? settings.pulsePeriod : 0.0
        };
    }

    getSAOSettings(settings = {}) {
        return {
            saoBias: settings && "saoBias" in settings ? settings.saoBias : 0.5,
            saoIntensity: settings && "saoIntensity" in settings ? settings.saoIntensity : 0.1,
            saoScale: settings && "saoScale" in settings ? settings.saoScale : 1000,
            saoKernelRadius: settings && "saoKernelRadius" in settings ? settings.saoKernelRadius : 30,
            saoMinResolution: settings && "saoMinResolution" in settings ? settings.saoMinResolution : 0,
            saoBlur: settings && "saoBlur" in settings ? settings.saoBlur : true,
            saoBlurRadius: settings && "saoBlurRadius" in settings ? settings.saoBlurRadius : 20,
            saoBlurStdDev: settings && "saoBlurStdDev" in settings ? settings.saoBlurStdDev : 4,
            saoBlurDepthCutoff: settings && "saoBlurDepthCutoff" in settings ? settings.saoBlurDepthCutoff : 0.0001
        };
    }

    getBouncePresets() {
        return {
            soft: {
                oscilations: 1,
                amplitude: 0.5,
                decay: 1,
            },
            medium: {
                oscilations: 2,
                amplitude: 2,
                decay: 2,
            },
            strong: {
                oscilations: 4,
                amplitude: 4,
                decay: 3,
            }
        };
    }

    getPresetAnimations() {
        const presets = this.getBouncePresets().medium;

        return Object.assign({
            duration: 3,
            delay: 0,
            axis: { x: 0, y: 1, z: 0 },
            overshoot: 0.2,
            assembleDir: "center",
            assembleDist: 1
        }, presets);
    }

    getAssetViewSettings() {
        return {
            thumbnail: {
                width: 500,
                height: 500
            }
        };
    }
    
    getAnimationDelaySettings() {
        return { 
            animationDelay: {
                min: 0,
                max: 120,
            }
        }
    }
}

export default SystemDefaults;
export { SystemDefaults };
